// extracted by mini-css-extract-plugin
module.exports = {"priceTableValue":"bMkRB59e"};